export const popup = (() => {
    const storageKey = 'popup-seen';
    const legacyKeyPrefix = 'popup-seen-';

    const readSeen = (storage) => {
        try {
            return JSON.parse(storage.getItem(storageKey)) || {};
        } catch {
            return {};
        }
    };

    const writeSeen = (storage, entries) => {
        storage.setItem(storageKey, JSON.stringify({ ...readSeen(storage), ...entries }));
    };

    const hasPreferenceConsent = () => !!(window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.preferences);

    window.addEventListener('CookiebotOnAccept', () => {
        if (!hasPreferenceConsent()) return;
        const sessionSeen = readSeen(sessionStorage);
        if (Object.keys(sessionSeen).length) writeSeen(localStorage, sessionSeen);
    });

    window.addEventListener('CookiebotOnDecline', () => {
        if (hasPreferenceConsent()) return;
        localStorage.removeItem(storageKey);
        Object.keys(localStorage)
            .filter((key) => key.startsWith(legacyKeyPrefix))
            .forEach((key) => localStorage.removeItem(key));
    });

    // Find all popups on the page
    const popupOverlays = document.querySelectorAll('[data-popup-id]');

    if (!popupOverlays.length) return;

    // Initialize each popup
    popupOverlays.forEach((popupOverlay) => {
        const popupId = popupOverlay.getAttribute('data-popup-id');
        const popupBlock = popupOverlay.querySelector('.popup-block');
        const closeButtons = popupOverlay.querySelectorAll('.popup-close');
        const closeBtn = popupOverlay.querySelector(`#close-btn-${popupId}`);

        let previousFocus;

        // Get popup settings from data attributes
        const onlyShowOnce = popupOverlay.getAttribute('data-only-show-once') === 'true';

        // Check if popup has been seen before
        const hasBeenSeen = () => {
            return popupId in readSeen(localStorage)
                || popupId in readSeen(sessionStorage)
                || localStorage.getItem(legacyKeyPrefix + popupId) !== null;
        };

        // Mark popup as seen
        const markAsSeen = () => {
            const entry = { [popupId]: new Date().toISOString() };
            writeSeen(sessionStorage, entry);
            if (hasPreferenceConsent()) writeSeen(localStorage, entry);
        };

        // Get all focusable elements within the popup
        const getFocusableElements = () => {
            if (!popupBlock) return [];

            const focusableSelectors = [
                'a[href]',
                'button:not([disabled])',
                'textarea:not([disabled])',
                'input:not([disabled])',
                'select:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');

            return Array.from(popupBlock.querySelectorAll(focusableSelectors));
        };

        // Focus trap handler
        const handleFocusTrap = (e) => {
            if (!popupOverlay.classList.contains('popup-overlay--visible')) return;
            if (e.key !== 'Tab') return;

            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];

            // If shift+tab on first element, go to last
            if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            }
            // If tab on last element, go to first
            else if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        };

        // Show popup function
        const showPopup = () => {
            previousFocus = document.activeElement;
            popupOverlay.classList.add('popup-overlay--visible');

            // Focus on close button for accessibility
            if (closeBtn) {
                setTimeout(() => closeBtn.focus(), 100);
            }

            // Mark as seen if OnlyShowOnce is enabled
            if (onlyShowOnce) {
                markAsSeen();
            }

            // Add focus trap listener
            document.addEventListener('keydown', handleFocusTrap);
        };

        // Hide popup function
        const hidePopup = () => {
            popupOverlay.classList.remove('popup-overlay--visible');

            // Return focus to previous element
            if (previousFocus) {
                previousFocus.focus();
            }

            // Remove focus trap listener
            document.removeEventListener('keydown', handleFocusTrap);
        };

        // Close button click handlers
        closeButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                hidePopup();
            });
        });

        // Close on overlay background click
        popupOverlay.addEventListener('click', (e) => {
            if (e.target === popupOverlay) {
                hidePopup();
            }
        });

        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && popupOverlay.classList.contains('popup-overlay--visible')) {
                hidePopup();
            }
        });

        // Show popup on page load (after a short delay) if it should be shown
        setTimeout(() => {
            // Only show if OnlyShowOnce is false OR if it hasn't been seen before
            if (!onlyShowOnce || !hasBeenSeen()) {
                showPopup();
            }
        }, 500);
    });
})();
